module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Playlist#1-13529489c0e246c6db739ac6294bfef0.svg";